<template>
  <div id="form">
    <h2>Lückentext</h2>
    <br><br>
    <p style="text-align: left;">
        In der Cochlea gibt es zwei Räume, welche sich die Scala Media und Scala Vestibuli nennen. Diese werden durch die Basilarmembran
        getrennt. Auf dieser Membran wird durch den Schall eine Wanderwelle ausgelöst.
    </p>
    <p style="text-align: left;">
        Hierbei gilt: Je  <input v-model="message1" placeholder="Feld1" /> die Frequenz, desto
        <input v-model="message2" placeholder="Feld2" /> an der Spitze der schneckenförmig aufgerollten Cochlea erfolgt die 
        <input v-model="message3" placeholder="Feld3" /> Auslenkung der Basilarmembran (Ortsprinzip der Wanderwelle).
    </p>

    <button id="button2" v-on:click="check">
        Prüfen
    </button>

  </div>
</template>
<script>

export default {
  name: "two-lists",
  display: "Two Lists",
  order: 1,

  data() {
    return {
        message1: '',
        message2: '',
        message3: '',
    }
  },
  methods: {
    log: function(evt) {
      window.console.log(evt);
    },
    check() {
        if ( (this.message1 && this.message1 == "tiefer" || this.message1 == "Tiefer") &&
             (this.message2 && this.message2 == "näher" || this.message2 == "Näher") &&
            (this.message3 && this.message3 == "max" || this.message3 == "maximale")
            ){
                alert("richtig");
                this.$store.commit('setTaskCompletionState', {varname: "aufbauForm4_done", state: true})
                localStorage.setItem("aufbauForm4_done", true);
            }
        else {
            alert("falsch")
        }
    }
  }
};
</script>

<style scoped>
/* #input1 {
    position: absolute;
    left: 260px;
    top: 305px
} */
/* #input2 {
    position: absolute;
    left: 530px;
    top: 205px
} */

#button2 {
    position: absolute;
    left: 650px;
    top: 550px;
    font-family: sans-serif;
    font-size: 20px;
    /* background-color: #297; */
    color: #fff;
    border: 0px;
    border-radius: 3px;
    padding: 20px;
    cursor: pointer;
    margin-bottom: 20px;
    background-color: #528382
}
#form {
    height: 1000px;;
}
</style>